var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleWithTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 407.476,
    height: 407.476,
    viewBox: "0 0 407.476 407.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10854",
    "data-name": "Group 10854",
    transform: "translate(0 0)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44471",
    "data-name": "Path 44471",
    d: "M262.577,148.361A114.215,114.215,0,1,0,148.361,262.58,114.345,114.345,0,0,0,262.577,148.361m-12.526,0A101.689,101.689,0,1,1,148.361,46.674a101.807,101.807,0,0,1,101.69,101.687",
    transform: "translate(55.375 55.378)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44472",
    "data-name": "Path 44472",
    d: "M150.734,78.994a6.267,6.267,0,0,0,.532-7.042L111.536,3.132a6.262,6.262,0,0,0-10.848,0L61.043,71.8A6.262,6.262,0,0,0,68.3,80.918a129.01,129.01,0,0,1,75.689.147,6.251,6.251,0,0,0,6.748-2.071M79.248,65.317l26.864-46.528L133.023,65.4a142.058,142.058,0,0,0-53.775-.087",
    transform: "translate(97.627 0.001)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44473",
    "data-name": "Path 44473",
    d: "M162.357,111.305a6.264,6.264,0,0,0,5.353-4.6l20.564-76.758a6.264,6.264,0,0,0-7.671-7.671L104.016,42.8a6.264,6.264,0,0,0-1.321,11.58A129.027,129.027,0,0,1,156.121,108a6.256,6.256,0,0,0,6.237,3.3m11.011-74.124L159.44,89.176A141.93,141.93,0,0,0,142.1,68.14a141.221,141.221,0,0,0-20.627-17.051Z",
    transform: "translate(161.148 35.778)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44474",
    "data-name": "Path 44474",
    d: "M133.8,151.265l68.815-39.731a6.262,6.262,0,0,0,0-10.848L133.945,61.042a6.264,6.264,0,0,0-9.121,7.254,128.515,128.515,0,0,1,5.605,37.594,128.487,128.487,0,0,1-5.747,38.095,6.263,6.263,0,0,0,9.113,7.28m53.159-45.155-46.612,26.914a141.732,141.732,0,0,0,2.614-27.134,141.574,141.574,0,0,0-2.527-26.644Z",
    transform: "translate(201.732 97.629)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44475",
    "data-name": "Path 44475",
    d: "M186.755,186.653a6.257,6.257,0,0,0,1.623-6.048l-20.522-76.588a6.261,6.261,0,0,0-11.577-1.321,128.988,128.988,0,0,1-53.623,53.421,6.265,6.265,0,0,0,1.3,11.593l76.756,20.567a6.337,6.337,0,0,0,1.62.212,6.258,6.258,0,0,0,4.428-1.835M142.515,142.1a141.5,141.5,0,0,0,17.051-20.627l13.905,51.895-51.989-13.931A141.711,141.711,0,0,0,142.515,142.1",
    transform: "translate(161.045 161.149)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44476",
    "data-name": "Path 44476",
    d: "M111.587,202.612l39.644-68.671a6.261,6.261,0,0,0-7.254-9.118,128.613,128.613,0,0,1-37.589,5.608,128.635,128.635,0,0,1-38.1-5.749,6.264,6.264,0,0,0-7.28,9.113l39.733,68.817a6.262,6.262,0,0,0,10.846,0m-5.2-59.655a141.427,141.427,0,0,0,26.638-2.532l-26.861,46.528L79.252,140.341a141.872,141.872,0,0,0,27.136,2.616",
    transform: "translate(97.573 201.733)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44477",
    "data-name": "Path 44477",
    d: "M29.944,188.379l76.588-20.522a6.263,6.263,0,0,0,1.321-11.58,128.989,128.989,0,0,1-53.421-53.623,6.263,6.263,0,0,0-11.59,1.3L22.276,180.708a6.263,6.263,0,0,0,6.048,7.883,6.336,6.336,0,0,0,1.62-.212m38.506-45.86a141.244,141.244,0,0,0,20.627,17.046l-51.9,13.908,13.931-51.989a141.718,141.718,0,0,0,17.339,21.036",
    transform: "translate(35.777 161.044)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44478",
    "data-name": "Path 44478",
    d: "M78.829,150.709a6.263,6.263,0,0,0,2.089-6.732,128.953,128.953,0,0,1,.142-75.689,6.263,6.263,0,0,0-9.113-7.28L3.133,100.741a6.26,6.26,0,0,0,0,10.846L71.8,151.231a6.267,6.267,0,0,0,7.031-.522M65.4,79.252a141.844,141.844,0,0,0-.084,53.775L18.789,106.163Z",
    transform: "translate(0 97.574)",
    fill: "#41af80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44479",
    "data-name": "Path 44479",
    d: "M54.376,107.855A128.908,128.908,0,0,1,108,54.434a6.265,6.265,0,0,0-1.3-11.593L29.945,22.275a6.266,6.266,0,0,0-7.671,7.671L42.8,106.534a6.262,6.262,0,0,0,5.34,4.6,6.486,6.486,0,0,0,.71.039,6.261,6.261,0,0,0,5.526-3.319m34.8-56.742A141.735,141.735,0,0,0,51.088,89.079l-13.908-51.9Z",
    transform: "translate(35.776 35.778)",
    fill: "#41af80"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWithTriangle);
export default __webpack_public_path__ + "static/media/circle_with_triangle.e3063a7b53d628bd8a86db620b3867ca.svg";
export { ForwardRef as ReactComponent };